import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Status } from '@df/core/status';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ScrollNavTargetDirective } from 'projects/app-default/src/app/ui/scroll-nav/scroll-nav-target.directive';
import { LocalProduct } from '../../../model/product/product.decorator';
import { CmsSpecificationSectionItemComponent } from './item/cms-specification-section-item.component';
import { NSpecificationSectionModal } from './modal/specification-section-modal.component';

@Component({
    selector: 'specification-section',
    templateUrl: './specification-section.html',
    standalone: true,
    imports: [ScrollNavTargetDirective, TranslationModule, NgClass, CmsSpecificationSectionItemComponent, ActionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecificationSectionComponent extends UiComponent {
    @Input({
        required: true
    })
    product!: LocalProduct<IProductDataV3>;

    private dfModalService = inject(DfModalService);

    protected modalStatus = new Status();

    protected sections?: number[];
    private allSections?: number[];

    override ngOnChanges(changes) {
        if (changes['product'] && this.product.data?.specification_section) {
            this.sections = this.product.data.specification_section.slice(0, 4);
            this.allSections = this.product.data.specification_section;
        }
        super.ngOnChanges(changes);
    }

    protected openModal() {
        const data: any = {
            sections: this.allSections
        };
        this.dfModalService.open(this.modalStatus, NSpecificationSectionModal.specificationSectionModalId, undefined, data);
    }
}
